import { ArrowLeftOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import {
  CustomButton,
  CustomInput,
  CustomSelect,
  CustomTitle,
} from "../../../components";
import {
  Button,
  Checkbox,
  Divider,
  Flex,
  Form,
  message,
  Row,
  Select,
} from "antd";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from 'libphonenumber-js';
import { useSpin } from "../../../components/SpinContext";
import { useToken } from "../../../common/helper";
import { externalShipmentAlert } from "../../../api's/shipment";
import { useNavigate } from "react-router-dom";
import { showCustomSuccessMessage } from "../../../common/utils";

const { Option } = Select;

const timeRangeList = [
  { id: 15, name: "15 mins" },
  { id: 30, name: "30 mins" },
  { id: 60, name: "60 mins" },
  { id: 120, name: "120 mins" },
];

const ExternalMapAlertsForm = ({ setShowAlertForm, externalToken }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken } = useToken();
  const [isFormValid, setIsFormValid] = useState(false);
  const [ETAAlerts, setETAAlerts] = useState(false);
  const [allValues, setAllValues] = useState(false);

  const [notifyVia, setNotifyVia] = useState("SMS");

  const handleMediumChange = (value) => {
    setNotifyVia(value);
    form.setFieldsValue({ contact_info: "" }); // Reset contact info when medium changes
  };






  const onFinish = (values) => {
    const model = form.getFieldsValue();

    const alertSelected =
      model.ETA_CHANGE || model.DELIVERY_EXCEPTION || model.SHIPMENT_DELIVERED;
    if (!alertSelected) {
      message.error("Get notified field is required");
      return;
    }

    model.token = externalToken;

    const alertTypes = [
      "ETA_CHANGE",
      "DELIVERY_EXCEPTION",
      "SHIPMENT_DELIVERED",
    ];
    model.alert_types = alertTypes.filter((key) => model[key]);

    alertTypes.forEach((key) => delete model[key]);

    if (!ETAAlerts) {
      delete model.eta_threshold;
    }

    submitAlertSettings(model);
  };


  const submitAlertSettings = (model) => {
    setIsFormValid(true);
    showSpin();

    externalShipmentAlert(model)
      .then((res) => {
        const data = res?.data || null;
        if (data?.data?.is_success) {
         // message.success(data?.data?.message);
          showCustomSuccessMessage(data?.data?.message);
          setShowAlertForm(false);
          form.resetFields();
          setETAAlerts(false);
        } else {
          message.error(data?.data?.message || "Failed to save settings");
        }
      })
      .catch((error) => {
        // unauthorize(error);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  return (
    <div>
      {/* Header  */}
      <Flex
        gap={18}
        align="center"
        style={{ marginBottom: "20px", position: "relative" }}
      >
        {/* <ArrowLeftOutlined
         
        /> */}

        <svg style={{ left: "15px", color: "#000", cursor: "pointer" }}
          onClick={() => setShowAlertForm(false)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3333 7.33329H5.21996L8.94663 3.60663L7.99996 2.66663L2.66663 7.99996L7.99996 13.3333L8.93996 12.3933L5.21996 8.66663H13.3333V7.33329Z" fill="black" />
        </svg>


        <CustomTitle
          text={"Get alerts"}
          fontSize={18}
          fontWeight={700}
          lineHeight="24px"
          marginTop={"0px"}
          color="#000"
          marginBottom="0"
        />
      </Flex>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={(changedValues, allValues) => {
          setAllValues(allValues);
          console.log("All current values: ", allValues);
        }}
        initialValues={{ notification_method: "SMS", eta_threshold: 15 }}
      >
        <CustomTitle
          text={"Notify via..."}
          fontSize={14}
          fontWeight={600}
          lineHeight="16px"
          marginTop={"0px"}
          color="#000"
          marginBottom="4px"
        />

        <Flex gap={8} alignItems="center" marginBottom="20px">
          <Form.Item name={"notification_method"}>
            <CustomSelect
              placeholder="Select"
              width="110px"
              height="36px"
              border="0px"
              bgColor="#F3F3F3"
              textColor="#5E5E5E"
              borderRadius="8px"
              placeholderColor="#5E5E5E"
              lineHeight="38px"
              onChange={handleMediumChange}
              options={[
                { value: "SMS", label: "Phone" },
                { value: "EMAIL", label: "Email" },
              ]}
            />
          </Form.Item>

          {notifyVia === "SMS" ? (
            <Form.Item
              name="contact_info"
              style={{ width: "100%" }}
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || value.trim() === "") {
                      return Promise.reject(new Error("Phone number is required"));
                    }
                    try {
                      const formatted = value.startsWith("+") ? value : `+${value}`;
                      if (isValidPhoneNumber(formatted)) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(new Error("Invalid phone number"));
                      }
                    } catch {
                      return Promise.reject(new Error("Invalid phone number"));
                    }
                  },
                },
              ]}
            >
              <PhoneInput
                style={{
                  width: "100%",
                }}
                country={"us"}
                onChange={(value, countryData, e, formattedValue) => {
                  form.setFieldsValue({ phone_number: formattedValue });
                }}
              />
            </Form.Item>

          ) : (
            <Form.Item
              name="contact_info"
              style={{ width: "100%" }}
              rules={[
                { required: true, message: "Email is required" },
                {
                  type: "email",
                  message: "Invalid email address",
                },
              ]}
            >
              <CustomInput
                placeholder="Enter email"
                height="36px"
                type="email"
                border="1px solid #E8E8E8"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          )}
        </Flex>

        <Divider />

        <CustomTitle
          text={"Get notified when..."}
          fontSize={14}
          fontWeight={600}
          lineHeight="16px"
          marginTop={"0px"}
          color="#000"
          marginBottom="4px"
        />

        <Flex>
          <Form.Item name="ETA_CHANGE" valuePropName="checked">
            <Checkbox
              className="small-checkbox"
              onChange={(e) => setETAAlerts(e.target?.checked)}
              style={{ fontSize: "14px", fontWeight: "400" }}
            >
              ETA changes by more than
            </Checkbox>
          </Form.Item>

          <Form.Item name="eta_threshold">
            <CustomSelect
              placeholder="Select"
              height="28px"
              border="0px"
              width={"100px"}
              disabled={!ETAAlerts}
              bgColor="#F3F3F3"
              textColor="#5E5E5E"
              borderRadius="8px"
              placeholderColor="#5E5E5E"
              lineHeight="38px"
              options={timeRangeList.map((opt) => ({
                value: opt.id,
                label: opt.name,
              }))}
            />
          </Form.Item>
        </Flex>

        <Form.Item name="DELIVERY_EXCEPTION" valuePropName="checked">
          <Checkbox className="small-checkbox" style={{ fontSize: "14px", fontWeight: "400" }}>
            A delivery exception has occurred
          </Checkbox>
        </Form.Item>

        <Form.Item name="SHIPMENT_DELIVERED" valuePropName="checked">
          <Checkbox className="small-checkbox" style={{ fontSize: "14px", fontWeight: "400" }}>
            Shipment delivered
          </Checkbox>
        </Form.Item>

        <Row gutter={[0, 8]} style={{ marginTop: "42px" }}>
          <CustomButton
            text={"Save"}
            width={"100%"}
            height={36}
            borderRadius={8}
            // bgColor={isFormValid ? "#F3F3F3" : "#000"}
            // color={isFormValid ? "#A6A6A6" : "#fff"}
            bgColor={"#000"}
            color={"#fff"}
            border="0px"
            fontSize={14}
            fontWeight={600}
            htmlType="submit"
          // isFormValid={isFormValid}
          />
          <CustomButton
            key="button1"
            width={"100%"}
            onClick={() => setShowAlertForm(false)}
            text={"Cancel"}
            bgColor="transparent"
            color="black"
            fontSize="14px"
            fontWeight="600"
            boxShadow="none"
            height="36px"
          />
        </Row>
      </Form>
      {contextHolder}
    </div>
  );
};

export default ExternalMapAlertsForm;
